import React from 'react';
const items = ['CNC-lathe specific', '1″ and 3/4″ holder systems', 'APGX insert platform', 'Application guidance by phone or email'];
export function TrustBand() {
  return <section aria-label="System compatibility summary" className="w-full bg-white" data-id="element-366" data-mp="35lqug7kwy7n2">
      <div className="mx-auto max-w-shell px-5 lg:px-10" data-id="element-367" data-mp="3acqrrdxy2rq3">
        <ul className="grid divide-y divide-rule border-x border-rule sm:grid-cols-2 sm:divide-y-0 lg:grid-cols-4" data-id="element-368" data-mp="3aea8t6rfd6sx">
          {items.map((item, i) => <li key={item} className={`flex items-start gap-3 px-5 py-5 sm:border-r sm:border-rule ${i < 2 ? 'sm:border-b sm:border-rule lg:border-b-0' : ''}`} data-id="element-369" data-mp="3k9lobranqi1q" data-mpi={i}>
              <span aria-hidden="true" className="mt-2.5 h-px w-4 shrink-0 bg-copper" data-id="element-370" data-mp="3taa34o7vkmfo" />
              <span className="text-[14px] font-medium leading-5 text-navy" data-id="element-371" data-mp="1yx26cr0ca0re">
                {item}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}